import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Item, dropdown } from './styles';
import { IconDropdown } from '../Icons';
import { TooltipHowItWorks } from './components/TooltipHowItWorks';
import { Typography } from '@utex/ui-kit';
export function Navigation(props) {
    var t = useTranslation('header').t;
    var view = props.view, activeItem = props.activeItem, onIdeasClick = props.onIdeasClick, onPortfolioClick = props.onPortfolioClick, onIPOClick = props.onIPOClick, onPreIPOClick = props.onPreIPOClick;
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(Item, { href: "/investments", view: view, isActive: activeItem === 'ideas', onClick: function (e) {
                    e.preventDefault();
                    onIdeasClick();
                }, "data-testid": "menu-link-investment-ideas" }, t('Invest Ideas')),
            React.createElement(Item, { href: "/investments/open-investment", view: view, isActive: activeItem === 'portfolio', onClick: function (e) {
                    e.preventDefault();
                    onPortfolioClick();
                }, "data-testid": "menu-link-my-portfolio" },
                React.createElement(Typography.Text, null, t('Portfolio'))),
            React.createElement(TooltipHowItWorks, { onIPOClick: onIPOClick, onPreIPOClick: onPreIPOClick, trigger: React.createElement(Item, { as: "button", type: "button", view: view, isActive: activeItem === 'howItWorks', "data-testid": "menu-link-how-it-works" },
                    React.createElement(Typography.Text, null, t('How It Works')),
                    React.createElement(IconDropdown, { width: 11, height: 20, css: dropdown })) }))));
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/Navigation/index.js
// module id = 1361
// module chunks = 118